class InstitutionList {
	constructor() {
		this.handleSearchFilter();
		this.handleSectorFilterSelect();
		this.handleRegionFilterSelect();
		this.handleRegionFilterSelectOption();
		this.handlePaginationList();
		this.handleSinglePageButtons();
		this.handleClearFilters();
	}

	handleSearchFilter() {
		const form = document.querySelector('#institution-list-search-form');
		const input = document.querySelector('#institution-list-search-input');

		if (form) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				const url = new URL(window.location.href);
				url.searchParams.delete('search');

				if (input.value) {
					url.searchParams.set('search', input.value);
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	activeLoader() {
		const loader = document.querySelector("#institution-register-loader");
		if (loader) {
			loader.classList.remove('hidden');
		}

		const fields = document.querySelectorAll("#institution-list-filters input, #institution-list-filters button, #institution-list-filters select");

		fields.forEach(field => {
			field.setAttribute('disabled', 'true');
		});
	}

	handleClearFilters() {
		const button = document.querySelector('#institution-list-clear-filters');

		if (button) {
			button.addEventListener('click', () => {
				const url = new URL(window.location.href);

				url.searchParams.delete('region');
				url.searchParams.delete('setor');
				url.searchParams.delete('search');

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handleSinglePageButtons() {
		const buttons = document.querySelectorAll('button.institution-single-button');

		buttons.forEach(button => {
			button.addEventListener('click', () => {
				const url = button.getAttribute('data-url');
				if (url) {
					this.activeLoader();
					location.replace(url);
				}
			});
		});
	}

	handleRegionFilterSelectOption() {
		const regionSelect = document.querySelector('#institution-list-region-select');

		if (regionSelect) {
			const selectedOption = regionSelect.options[regionSelect.selectedIndex];

			if (selectedOption) {
				this.setSectorOptions(selectedOption);
			}
		}
	}

	setSectorOptions(selectedOption) {

		if (!selectedOption.getAttribute('data-item')) {
			return;
		}

		const data = JSON.parse(selectedOption.getAttribute('data-item'));

		const sectorsSelect = document.querySelector('#institution-list-sector-select');
		const currentSector = sectorsSelect.getAttribute('data-sector');

		if (data.sectors) {
			sectorsSelect.innerHTML = '<option value="">Selecione um Setor</option>';
		}

		data.sectors.forEach(sector => {
			const option = document.createElement('option');
			option.value = sector.id;
			option.innerText = sector.name;

			if (currentSector == sector.id) {
				option.selected = true;
			}

			sectorsSelect.appendChild(option);
		});
	}

	handleSectorFilterSelect() {
		const select = document.querySelector('#institution-list-sector-select');

		if (select) {
			select.addEventListener('change', () => {
				const url = new URL(window.location.href);
				url.searchParams.delete('setor');

				if (select.value) {
					url.searchParams.set('setor', select.value);
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handleRegionFilterSelect() {
		const select = document.querySelector('#institution-list-region-select');

		if (select) {
			select.addEventListener('change', () => {
				const url = new URL(window.location.href);
				url.searchParams.delete('region');

				if (select.value) {
					url.searchParams.set('region', select.value);
				}

				this.activeLoader();
				location.replace(url.toString());
			});
		}
	}

	handlePaginationList() {
		const paginationItems = document.querySelectorAll('.pagination-item');

		paginationItems.forEach(item => {
			const page = item.getAttribute('data-page');

			if (page) {
				const url = new URL(window.location.href);
				item.href = `${item.href}page/${page}/?${url.searchParams.toString()}`;
			}
		});
	}
}


document.addEventListener('DOMContentLoaded', () => {
	new InstitutionList();
});
